import React from "react";

const PopOverLimit = (props) => {
    return (
        <li>
            <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-7">
                    <label className="label-primary">{props.Denominacion}</label>
                </div>
                <div className="col-md-4">
                    <label className="label-secondary">${props.LimiteCompra}</label>
                </div>
            </div>
        </li>
    );
}

export default PopOverLimit